import { Label } from 'reactstrap';
import styled from 'styled-components';

export const LabelStyled = styled(Label)`
  font-weight: 700;
`;
